<div class="title">Map Details</div>
<div *ngIf="map != null">
    <label for="grid-scale">Grid Scale</label>
    <input id="grid-scale" type="number" [(ngModel)]="map.data.gridScale" (change)="update(map)" />

    <button (click)="delete(map)">Delete Map</button>
    <button (click)="lock(true, map)" *ngIf="!map.data.locked">Lock in Place</button>
    <button (click)="lock(false, map)" *ngIf="map.data.locked">Unlock</button>
</div>